import React from "react";

export default function GlobalToast() {
  const [items, setItems] = React.useState([]);
  React.useEffect(() => {
    const onErr = (e) => {
      const d = e.detail || {};
      setItems((prev) => {
        const next = prev.concat([{ id: d.ts || Date.now(), ...d }]);
        return next.slice(-3);
      });
    };
    window.addEventListener("fs-error", onErr);
    return () => window.removeEventListener("fs-error", onErr);
  }, []);
  if (!items.length) return null;
  return (
    <div style={{ position: "fixed", top: 12, right: 12, zIndex: 2000, maxWidth: 420 }}>
      {items.map((t) => (
        <div key={t.id} className="alert alert-warning shadow-sm d-flex align-items-start gap-2" style={{ background: "#fff8e1", borderColor: "#ffe082" }}>
          <div className="flex-grow-1">
            <div><strong>Write failed</strong>{t.operation ? ` — ${t.operation}` : ""}</div>
            <div className="small text-muted">{t.code ? `${t.code}: ` : ""}{t.message}</div>
          </div>
          {t.retry && (
            <button className="btn btn-sm btn-outline-primary" onClick={async () => {
              try { await t.retry(); setItems(list => list.filter(x => x.id !== t.id)); }
              catch (err) { /* keep visible */ }
            }}>Retry</button>
          )}
          <button className="btn btn-sm btn-link text-muted" onClick={() => setItems(list => list.filter(x => x.id !== t.id))}>×</button>
        </div>
      ))}
    </div>
  );
}
